import ViewListIcon from '@mui/icons-material/ViewList'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'

interface MenuGamePortfolioProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export default function MenuGamePortfolio({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuGamePortfolioProps) {
  const { formatMessage } = useIntl()

  const isDefaultPath = pathname.startsWith('/casino/game-portfolio')

  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href="/casino/game-portfolio"
        selected={isDefaultPath}
      >
        <ListItemIcon>
          <ViewListIcon />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({ id: 'casino.submenu.game_portfolio.title' })}
        />
      </MenuItem>
    </div>
  )
}
